(function () {
  const SUCCESS_TEXT = 'Hinzugefügt';
  const SUCCESS_HTML = '<span>✓ Hinzugefügt</span>';
  const LOADING_HTML = '<span>Hinzugefügt...</span>';

  function getCartItemsComponents() {
    return Array.from(document.querySelectorAll('cart-items-component[data-section-id]'));
  }

  function getSectionIds() {
    return [...new Set(getCartItemsComponents().map((item) => item.dataset.sectionId).filter(Boolean))];
  }

  function getCartAddUrl() {
    if (window.Theme?.routes?.cart_add_url) return window.Theme.routes.cart_add_url;
    const root = window.StorefrontLocale?.root || window.Shopify?.routes?.root || '/';
    return `${root}cart/add.js`;
  }

  function getCartUpdateUrl() {
    if (window.Theme?.routes?.cart_update_url) return window.Theme.routes.cart_update_url;
    const root = window.StorefrontLocale?.root || window.Shopify?.routes?.root || '/';
    return `${root}cart/update.js`;
  }

  function getExistingDiscountCodes() {
    return [
      ...new Set(
        Array.from(document.querySelectorAll('.cart-discount__pill[data-discount-code]'))
          .map((pill) => pill.dataset.discountCode?.trim())
          .filter(Boolean)
      ),
    ];
  }

  async function fetchCart() {
    const root = window.StorefrontLocale?.root || window.Shopify?.routes?.root || '/';
    const response = await fetch(`${root}cart.js`, {
      headers: { Accept: 'application/json' },
    });

    if (!response.ok) throw new Error('Der Warenkorb konnte nicht aktualisiert werden.');
    return response.json();
  }

  async function refreshCartState(addResponse) {
    const cart = await fetchCart();
    const sections = addResponse?.sections || {};
    const sectionIds = Object.keys(sections);

    getCartItemsComponents().forEach((component) => {
      const sectionId = component.dataset.sectionId;
      if (!sectionId || !sections[sectionId]) return;
      const html = new DOMParser().parseFromString(sections[sectionId], 'text/html');
      const replacement = Array.from(html.querySelectorAll('cart-items-component[data-section-id]')).find(
        (item) => item.dataset.sectionId === sectionId
      );
      if (replacement) component.replaceWith(replacement);
    });

    document.dispatchEvent(
      new CustomEvent('cart:update', {
        bubbles: true,
        detail: {
          resource: cart,
          sourceId: 'custom-cart-add',
          data: {
            source: 'custom-cart-add',
            itemCount: cart.item_count,
            sections,
          },
        },
      })
    );

    document.dispatchEvent(new CustomEvent('cart:updated', { bubbles: true, detail: { cart, sections } }));
    document.dispatchEvent(new CustomEvent('ajaxProduct:added', { bubbles: true, detail: { cart } }));

    if (!sectionIds.length) {
      document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
    }

    return cart;
  }

  function appendSectionsToFormData(formData) {
    const sectionIds = getSectionIds();
    if (!sectionIds.length) return;
    formData.set('sections', sectionIds.join(','));
    formData.set('sections_url', window.location.pathname);
  }

  async function applyDiscountCode(discountCode) {
    const existingCodes = getExistingDiscountCodes();
    const allCodes = existingCodes.some((code) => code.toLowerCase() === discountCode.toLowerCase())
      ? existingCodes
      : [...existingCodes, discountCode];
    const sectionIds = getSectionIds();
    const body = { discount: allCodes.join(',') };
    if (sectionIds.length) body.sections = sectionIds;

    const response = await fetch(getCartUpdateUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: JSON.stringify(body),
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Der Aktionscode konnte nicht angewendet werden.');
    }

    const discount = Array.isArray(data.discount_codes)
      ? data.discount_codes.find((entry) => entry.code?.toLowerCase() === discountCode.toLowerCase())
      : null;

    return {
      data,
      applicable: discount ? discount.applicable !== false : false,
    };
  }

  async function addFormToCart(form) {
    const formData = new FormData(form);
    appendSectionsToFormData(formData);

    const response = await fetch(getCartAddUrl(), {
      method: 'POST',
      headers: {
        Accept: 'application/json',
        'X-Requested-With': 'XMLHttpRequest',
      },
      body: formData,
    });

    const data = await response.json().catch(() => ({}));
    if (!response.ok || data.status) {
      throw new Error(data.description || data.message || 'Der Artikel konnte nicht in den Warenkorb gelegt werden.');
    }

    window.deinFriseurOpenAIAds?.itemsAdded([{ id: formData.get('id'), quantity: Number(formData.get('quantity') || 1) }]);

    const discountCode = form.dataset.discountCode?.trim();
    if (!discountCode) {
      await refreshCartState(data);
      return { data, discountCode: '', discountApplied: null, discountError: null };
    }

    try {
      const discountResult = await applyDiscountCode(discountCode);
      await refreshCartState(discountResult.data);
      return {
        data,
        discountCode,
        discountApplied: discountResult.applicable,
        discountError: discountResult.applicable ? null : new Error('Der Aktionscode ist noch nicht anwendbar.'),
      };
    } catch (discountError) {
      await refreshCartState(data);
      return { data, discountCode, discountApplied: false, discountError };
    }
  }

  function setFormStatus(form, message, tone = '') {
    const status = form.closest('[data-promo-actions]')?.querySelector('[data-cart-status]');
    if (!status) return;
    status.textContent = message;
    status.dataset.tone = tone;
  }

  function setButtonSuccess(button, originalHTML) {
    if (!button) return;
    button.innerHTML = SUCCESS_HTML;
    setTimeout(() => {
      button.disabled = false;
      button.innerHTML = originalHTML;
    }, 1500);
  }

  function setButtonError(button, originalHTML, error) {
    console.error(error);
    if (!button) return;
    button.textContent = 'Fehler';
    setTimeout(() => {
      button.disabled = false;
      button.innerHTML = originalHTML;
    }, 2000);
  }

  function shouldHandleForm(form) {
    if (!(form instanceof HTMLFormElement)) return false;
    const action = form.getAttribute('action') || '';
    if (!action.includes('/cart/add')) return false;
    if (form.closest('product-form-component')) return false;
    if (form.classList.contains('elumen-ajax-form')) return false;
    return Boolean(form.querySelector('[name="id"]'));
  }

  document.addEventListener(
    'submit',
    async (event) => {
      const form = event.target;
      if (!shouldHandleForm(form)) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      const button = form.querySelector('button[type="submit"], button:not([type]), input[type="submit"]');
      const originalHTML = button?.innerHTML || '';

      if (button) {
        button.disabled = true;
        button.innerHTML = LOADING_HTML;
      }

      try {
        const result = await addFormToCart(form);
        setButtonSuccess(button, originalHTML);
        if (result.discountCode && result.discountApplied === false) {
          setFormStatus(
            form,
            `Artikel hinzugefügt. Aktionscode bitte im Warenkorb eingeben: ${result.discountCode}.`,
            'warning'
          );
        } else {
          setFormStatus(form, 'Artikel hinzugefügt.');
        }
      } catch (error) {
        setButtonError(button, originalHTML, error);
        setFormStatus(form, error.message || 'Der Artikel konnte nicht hinzugefügt werden.', 'error');
      }
    },
    true
  );

  window.deinFriseurCartAdd = {
    refresh: refreshCartState,
    addForm: addFormToCart,
    applyDiscount: applyDiscountCode,
    successText: SUCCESS_TEXT,
  };
})();
